
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/math-vault",
      function () {
        return require("private-next-pages/math-vault/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/math-vault"])
      });
    }
  